import { BASE_URL_ORGANIZATION } from "../services/organizationAPI";

import { useAuth } from "../../auth/hooks";
import { Organization, OrganizationPatch } from "../types/organization.types";

import { OrderByType, useGenericAPI } from "../../../utils/genericAPI/useGenericAPI";

/**
 * useOrganizations
 * Method to get all organizations
 * @returns
 */
export default function useOrganizations(config?: {
  pageSize?: number;
  orderBy?: OrderByType<Organization>;
}) {
  const { setHeaderAuthToRequest } = useAuth();

  setHeaderAuthToRequest();
  const { getAllQuery, createNew } = useGenericAPI<
    Organization,
    OrganizationPatch,
    OrganizationPatch
  >({
    baseURL: BASE_URL_ORGANIZATION,
    APIname: "organizations",
    pageSize: config?.pageSize,
    orderBy: config?.orderBy,
  });

  return {
    allOrganizationsQuery: { ...getAllQuery },
    createNewOrgnizationQuery: {
      ...createNew,
    },
  };
}
